module.exports = __webpack_public_path__ + "img/down-arrow-white.b1c7b25a.svg";